import React, { Component } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/NavBar";
import img from "../imgs/clearRain.jpeg";

const jumbotron = {
  backgroundImage: "url(" + img + ")",
  backgroundPosition: "center",
  backgroundRrepeat: "no-repeat",
  backgroundSize: "cover",
  color: "white",
  height: "95vh"
};



export default class Home extends Component {
  render() {
    return (
      <div>
        <Navbar />
        <div className="jumbotron jumbotron-fluid" style={jumbotron}>
          <div className="container ">
            <div className="row-fluid" style={{textAlign:'center'}}>
            <div className="col" style={{float:'center', marginTop:'8vh'}}>
              <h1 className="display-3" style={{ fontSize:"10vh", fontFamily:'lato', textShadow: '2px 2px 2px #000', margin:'2vh' }}>
                CRY FOR RAIN
              </h1>
              
              <p className="display-3" style={{ fontSize:"4vh", fontFamily:'lato', textShadow: '2px 2px 2px #000',  margin:'4vh' }}>
              A MEMOIR</p></div>
              <p className="display-3" style={{ fontSize:"4vh", fontFamily:'lato', textShadow: '2px 2px 2px #000' , margin:'4vh' }}>BY</p>
              <p className="display-3" style={{ fontSize:"6vh", fontFamily:'lato', textShadow: '2px 2px 2px #000',  margin:'4vh', wordSpacing:'2vh' }}>MELINEH PETROSIAN</p>
              <p className="display-3" style={{ fontSize:"4vh", fontFamily:'lato', textShadow: '2px 2px 2px #000',  margin:'4vh' }}>AVAILABLE NOW</p>
            </div>
          </div>
        </div>
        {/* <Footer/> */}
      </div>
    );
  }
}
